import { builtIn, override } from "./rules.js";
import { baseRules, CALLOUTS } from "./base.js";

const COLOURS = { Note: "0172AD", Tip: "398712", Important: "8352C6", Warning: "D39E00", Caution: "D93526" };

const extraCss = `article[data-callout] { border-left: 0.35rem solid var(--callout-colour); }
article[data-callout] > p:last-child { margin-bottom: 0; }
${CALLOUTS.map((name) => `article[data-callout='${name.toLowerCase()}'] { --callout-colour: #${COLOURS[name]}; }`).join("\n")}`;

export const pico = builtIn({
  id: "pico",
  name: "Pico",
  basedOn: "pico",
  description: "The same semantic HTML, styled by Pico CSS. Callouts become cards with a coloured edge.",
  css: ["vendor/pico.min.css"],
  exportCss: ["https://cdn.jsdelivr.net/npm/@picocss/pico@2.1.1/css/pico.min.css"],
  extraCss,
  wrapper: "main.container",
  rules: override(baseRules, {
    "p|Caption": { html: "p:fresh > small:fresh" },
    "p|Lead": { html: "p:fresh > strong" },
    "r|Badge": { html: "mark" },
    ...Object.fromEntries(CALLOUTS.map((name) => [`p|${name}`, { html: `article[data-callout='${name.toLowerCase()}'] > p:fresh` }])),
  }),
});
